import axios from "axios";

export function getClassTempListByCityId(obj) {
  const config = {
    params: obj,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/form", config);
}

export function getClassTempList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/classtemplist", config);
}

export function getClassTempList2(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/classtemplist2", config);
}

export function postNewClassTemp(data) {
  const config = {
    params: data,
  };
  return axios.post(
    process.env.VUE_APP_API_URL + "Class/classtempadd",
    null,
    config
  );
}

export function updateClassTemp(data) {
  const config = {
    params: data,
  };
  return axios.put(
    process.env.VUE_APP_API_URL + "Class/classtempupdate",
    null,
    config
  );
}

export function deleteClassTemp(classTempId) {
  const config = {
    params: {
      classTempId: classTempId,
    },
  };
  return axios.delete(
    process.env.VUE_APP_API_URL + "Class/classtempdeleted",
    config
  );
}
